import { Typography } from '@mui/material';
import templateEngine from '../TemplateEngine';
import ViewModeRenderer from './ViewModeRenderer';

/**
 * Validates entry and viewMode before iframe render.
 * Returns a JSX snippet if rendering should be short-circuited, null otherwise.
 */
const EntryGuard = {

    /**
     * @param {object} entry
     * @param {string} viewMode
     * @returns {JSX.Element|null}
     */
    validate(entry, viewMode) {
        // Call as function — component call is always truthy even when null
        const viewModeEl = ViewModeRenderer({ entry, viewMode });
        if (viewModeEl) return viewModeEl;

        if (!entry?.tid) return (
            <Typography variant="caption" sx={{ color: 'var(--j-muted)', p: 1, display: 'block' }}>
                No template linked to this entry.
            </Typography>
        );

        if (!templateEngine.getTemplate(entry.tid)) return (
            <Typography variant="caption" sx={{ color: 'var(--j-muted)', p: 1, display: 'block' }}>
                Template not found or not approved yet.
            </Typography>
        );

        return null;
    },
};

export default EntryGuard;
